/**
 * EdClock API origin for Improwise client.
 * Empty / unset → same-origin relative URLs (Vue proxy → 127.0.0.1:8001).
 */
export function getEdClockApiBase() {
  const raw = process.env.VUE_APP_API_EDCLOCK;
  if (raw == null || String(raw).trim() === '' || String(raw) === 'undefined') {
    return '';
  }
  return String(raw).replace(/\/+$/, '');
}

export function edClockApiUrl(path) {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${getEdClockApiBase()}${normalized}`;
}
